/**
 * PATH: packages/email-hub/src/feature/components/RecipientChip.tsx
 * FILE_ID: EMAILHUB-COMPOSE-RECIPIENT-CHIP-001
 * PURPOSE: One To/Cc/Bcc chip that can be selected or copied without losing the remove button.
 * WHY: The composer row focuses the input on click, which used to collapse a text selection.
 */
import { X } from 'lucide-react'

export function RecipientChip({
  email,
  onRemove,
}: {
  email: string
  onRemove: (email: string) => void
}) {
  return (
    <span
      data-quotech-address={email}
      className="inline-flex items-center gap-1 px-2 py-0.5 text-sm bg-muted rounded-full text-foreground select-text"
      onMouseDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
      onContextMenu={(event) => {
        event.preventDefault()
        event.stopPropagation()
        const address = email.trim()
        if (!address) return
        void navigator.clipboard.writeText(address).catch(() => undefined)
      }}
    >
      {email}
      <button
        type="button"
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => {
          event.stopPropagation()
          onRemove(email)
        }}
        className="text-muted-foreground hover:text-destructive"
        aria-label={`Remove ${email}`}
      >
        <X className="h-3 w-3" />
      </button>
    </span>
  )
}
